import { linkToTeacherDashboard } from "../../links";

export function linkToClassPage(classId: string = ":classId") {
  return `${linkToTeacherDashboard()}/class/${classId}`;
}
